<template>
  <div>
    <div class="flex flex-wrap">
      <div class="w-1/2 p-3">
        <div class="mb-2 bg-white">
          <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
            <div class="m-3">
              <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Total Earning</h2>
              <div class="text-4xl text-left text-black font-bold">${{parseFloat(earningToDate).toFixed(2)}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/2 p-3">
        <div class="mb-2 bg-white">
          <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
            <div class="m-3">
              <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Balance</h2>
              <div class="text-4xl text-left text-black font-bold">${{parseFloat(artistBalance).toFixed(2)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap">
      <div class="w-full p-3">
        <div class="mb-2 bg-white">
          <div class="card cursor-pointer border border-gray-400 rounded-lg">
            <div class="m-3">
              <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Number Songs Sold {{new Date().getFullYear()}}
                <span class="text-xs text-teal-800 float-right"></span></h2>
              <highcharts class="hc2 h-300" :options="soldSong" ref="chart2"></highcharts>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="flex flex-wrap">
      <div class="w-full p-3 ">
        <div class="mb-2 bg-white">
          <div class="card cursor-pointer border border-gray-400 rounded-lg">
            <div class="m-3">
              <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Weekly Customer
                <span class="text-xs text-teal-800 float-right"></span></h2>
              <highcharts class="hc" :options="weeklyCustomer" ref="chart" :class="'h-300'"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap">
      <div class="w-1/3 p-3">
        <div class="mb-2 bg-white">
          <div class="pb-3 card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
            <div class="m-3">
              <h2 class="text-xs text-left font-bold border-b border-black">Most Popular Song</h2>
              <div class="h-300 overflow-y-auto">
                <ul class="flex mb-0 list-none flex-wrap pb-4 flex-row">
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class=" text-xs uppercase px-5 py-3  block leading-normal text-black" v-on:click="toggleTabPopularSong(1)" v-bind:class="{'': popularSongTabIndex !== 1, 'font-bold border-b border-black': popularSongTabIndex === 1}">
                      Lifetime
                    </a>
                  </li>
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class="text-xs uppercase px-5 py-3 block leading-normal text-black" v-on:click="toggleTabPopularSong(2)" v-bind:class="{'': popularSongTabIndex !== 2, 'font-bold border-b border-black': popularSongTabIndex === 2}">
                      Active Year
                    </a>
                  </li>
                </ul>
                <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-2" >
                  <div class="flex-auto">
                    <div class="tab-content tab-space">
                      <div v-bind:class="{'hidden': popularSongTabIndex !== 1, 'block': popularSongTabIndex === 1}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularSongLifetime.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularSongLifetime.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularSongLifetime" :key="song.id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.total_purchase}}</span>
                          </li>
                        </ol>
                      </div>
                      <div v-bind:class="{'hidden': popularSongTabIndex !== 2, 'block': popularSongTabIndex === 2}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularSongCurrent.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularSongCurrent.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularSongCurrent" :key="song.id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.total_purchase}}</span>
                          </li>
                        </ol>
                      </div>

                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="w-1/3 p-3">
        <div class="mb-2 bg-white">
          <div class="pb-3 card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
            <div class="m-3">
              <h2 class="text-xs text-left font-bold border-b border-black">Most Popular Album</h2>
              <div class="h-300 overflow-y-auto">
                <ul class="flex mb-0 list-none flex-wrap pb-4 flex-row">
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class=" text-xs uppercase px-5 py-3  block leading-normal text-black" v-on:click="toggleTabPopularAlbum(1)" v-bind:class="{'': popularAlbumTabIndex !== 1, 'font-bold border-b border-black': popularAlbumTabIndex === 1}">
                      Lifetime
                    </a>
                  </li>
                  <li class="-mb-px flex-auto text-center cursor-pointer ">
                    <a class="text-xs uppercase px-5 py-3 block leading-normal text-black" v-on:click="toggleTabPopularAlbum(2)" v-bind:class="{'': popularAlbumTabIndex !== 2, 'font-bold border-b border-black': popularAlbumTabIndex === 2}">
                      Active year
                    </a>
                  </li>
                </ul>
                <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6">
                  <div class="flex-auto">
                    <div class="tab-content tab-space">
                      <div v-bind:class="{'hidden': popularAlbumTabIndex !== 1, 'block': popularAlbumTabIndex === 1}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularAlbumLifetime.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularAlbumLifetime.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularAlbumLifetime" :key="song.id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.total_purchase}}</span>
                          </li>
                        </ol>
                      </div>
                      <div v-bind:class="{'hidden': popularAlbumTabIndex !== 2, 'block': popularAlbumTabIndex === 2}" class="mx-400 overflow-y-auto">
                        <ol class="list-outside pl-6" :class="dataPopularAlbumCurrent.length>0?'list-decimal':''">
                          <li class="text-center text-sm font-bold text-black p-3" v-if="dataPopularAlbumCurrent.length===0">No Data</li>
                          <li class="text-left text-sm font-bold text-black mb-3" v-for="song in dataPopularAlbumCurrent" :key="song.id">
                            {{song.name}}<span class="text-xs text-teal-800 float-right">{{song.total_purchase}}</span>
                          </li>
                        </ol>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/3 p-3">
        <div class="mb-2 bg-white">
          <div class="card cursor-pointer border border-gray-400 rounded-lg hover:shadow-md hover:border-opacity-0 transform hover:-translate-y-1 transition-all duration-200">
            <div class="m-3">
              <h2 class="text-xs text-left font-bold mb-2 border-b border-black mb-3">Top Countries {{ new Date().getFullYear()}}</h2>
              <div class="h-300 overflow-y-auto px-3">
                <ol class="list-outside pl-4" :class="dataTopCountry.length>0?'list-decimal':''">
                  <li class="text-center text-sm font-bold text-black p-3" v-if="dataTopCountry.length===0">No Data</li>
                  <li class="text-left text-sm font-bold text-black mb-3" v-for="country in dataTopCountry" :key="country.country_code">
                    {{country.country_name}}<span class="text-xs text-teal-800 float-right">{{country.total}}</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'StatisticArtist',
  props: {
    isLoaded: {
      type: Boolean,
    },
  },
  data() {
    return {
      weeklyCustomer: {
        chart: {
          type: 'area',
        },
        title: false,
        subtitle: false,
        yAxis: {
          title: false,
        },
        xAxis: {
          categories: [],
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">Customer: </td>' +
            '<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
          },
        },
        series: [{
          name: 'Weeks',
          data: [],
        }],
      },
      soldSong: {
        chart: {
          type: 'column',
        },
        title: false,
        subtitle: false,
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Number of sold',
          },
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">Song: </td>' +
            '<td style="padding:0"><b>{point.y} song</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [{
          name: 'Weeks',
          data: [],

        }],
      },
      dataTopCountry: [],
      popularSongTabIndex: 1,
      dataPopularSongLifetime: [],
      dataPopularSongCurrent: [],
      popularAlbumTabIndex: 1,
      dataPopularAlbumLifetime: [],
      dataPopularAlbumCurrent: [],

    };
  },
  computed: {
    ...mapGetters('StatisticModule', [
      'listTopCountry', 'listWeeklyCustomer', 'listSoldSong',
      'listPopularSong', 'listPopularSongCurrent',
      'listPopularAlbum', 'listPopularAlbumCurrent',
      'earningToDate', 'artistBalance',
    ]),
  },
  watch: {
    isLoaded: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.requestListTopCountry();
        await this.requestListWeeklyCustomer();
        await this.requestListSoldSong();
        await this.requestListPopularSong();
        await this.requestListPopularAlbum();
        await this.requestEarningToDate();
        await this.requestArtistBalance();
      },
    },
    listTopCountry: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataTopCountry = val.data;
        }
      },
    },
    listPopularSong: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataPopularSongLifetime = val.data;
        }
      },
    },
    listPopularSongCurrent: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataPopularSongCurrent = val.data;
        }
      },
    },
    listPopularAlbum: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataPopularAlbumLifetime = val.data;
        }
      },
    },
    listPopularAlbumCurrent: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data != undefined) {
          this.dataPopularAlbumCurrent = val.data;
        }
      },
    },
    listWeeklyCustomer: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data !== undefined) {
          if (val.data.length > 0) {
            const dataSeries = [];
            const dataWeek = [];
            let maxWeek = 0;
            const categories = [];
            val.data.forEach((week) => {
              const weekData = week.week.split(' ');
              const weekNumber = parseInt(weekData[1]);
              dataWeek[weekNumber - 1] = week.total;
              maxWeek = weekNumber > maxWeek ? weekNumber : maxWeek;
            });
            for (let i = 0; i <= maxWeek - 1; i++) {
              categories.push(`Week ${i + 1}`);
              dataSeries.push(dataWeek[i] !== undefined ? dataWeek[i] : 0);
            }
            this.weeklyCustomer.xAxis.categories = categories;
            this.weeklyCustomer.series[0].data = dataSeries;
          }
        }
      },
    },
    listSoldSong: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val.data !== undefined) {
          if (val.data.length > 0) {
            const dataSeries = [];
            const dataWeek = [];
            let maxWeek = 0;
            const categories = [];
            val.data.forEach((week) => {
              const weekData = week.week.split(' ');
              const weekNumber = parseInt(weekData[1]);
              dataWeek[weekNumber - 1] = week.total;
              maxWeek = weekNumber > maxWeek ? weekNumber : maxWeek;
            });
            for (let i = 0; i <= maxWeek - 1; i++) {
              categories.push(`Week ${i + 1}`);
              dataSeries.push(dataWeek[i] !== undefined ? dataWeek[i] : 0);
            }
            this.soldSong.xAxis.categories = categories;
            this.soldSong.series[0].data = dataSeries;
          }
        }
      },
    },
  },
  methods: {
    ...mapActions('StatisticModule', ['requestListTopCountry', 'requestListWeeklyCustomer', 'requestListSoldSong', 'requestListPopularSong', 'requestListPopularAlbum', 'requestEarningToDate', 'requestArtistBalance']),
    toggleTabPopularSong(tabNumber) {
      this.popularSongTabIndex = tabNumber;
    },
    toggleTabPopularAlbum(tabNumber) {
      this.popularAlbumTabIndex = tabNumber;
    },
  },
  components: {
    highcharts: Chart,
  },
};
</script>
<style scoped>
.count-listener{
  font-size: 36px;
}
.hc{
  width:100%;
}
.h-400{
  height: 400px;
  overflow-y: auto;
}
.h-300{
   height: 320px;
 }
.overflow-y-auto{
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Statistic/Artist.vue